import { createContext } from 'react'

import { FlowChartServiceInterface } from '../lib/services/FlowChartService'

export const ServicesContext = createContext<FlowChartServiceInterface>({})

export const ServicesProvider = ServicesContext.Provider
